export enum SessionState {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
    EXPIRING = 'EXPIRING',
    REFRESHING = 'REFRESHING',
    VERIFYING = 'VERIFYING',
}
